import { IInitialContextResult } from "../services/contextService";
import ICategory from "../interfaces/ICategory";

const CategoryMapper = {
    apiToDomain: (api: IInitialContextResult["kategoriat"][0]): ICategory => ({
        id: api.id,
        name: api.nimi,
        icon: api.ikoni
    }),
};

export default CategoryMapper
